import { render, staticRenderFns } from "./SurveyList.vue?vue&type=template&id=60439d8e"
import script from "./SurveyList.vue?vue&type=script&lang=js"
export * from "./SurveyList.vue?vue&type=script&lang=js"
import style0 from "./SurveyList.vue?vue&type=style&index=0&id=60439d8e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports